import { connect } from 'react-redux';
import SSO from './SSO';
import { actions } from './actions';

function mapStateToProps(state) {
  return {
    redirectTo: state.auth.redirectTo,
    loginStatus: state.login.loginStatus,
    invalidLicense: state.login.invalidLicense,
    msg: state.login.msg
  };
}
function mapDispatchToProps(dispatch) {
  return {
    postLogin: (code, protocol, hostname) => dispatch(actions.postLogin(code, protocol, hostname)),
    clearLoginStatus: () => dispatch(actions.clearLoginStatus()),
  };
}

const SSOContainer = connect(mapStateToProps, mapDispatchToProps)(SSO);

const route = {
  path: '/sso-login',
  component: SSOContainer
};

export default SSOContainer;
export { route, mapStateToProps, mapDispatchToProps, SSOContainer as SSO };